import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import NavigationMenu from './NavigationMenu';
import type { NavigationMenuProps } from './NavigationMenu/NavigationMenu';
import type { TitleProps } from './Title/Title';
import { ThemeContext } from '../../context';
import { Z_INDEX_MAP, Z_INDEX_NAV_KEY } from '../../util/zIndexConstants';
import { mapBackgroundToCSS, mapFontViewToSerializedStyles } from '../../util/mappers';

// import HeaderWeddingSummary from './HeaderWeddingSummary';

type HeaderProps = NavigationMenuProps & TitleProps;

const Header = ({ title, navItems, slug }: HeaderProps): JSX.Element => {
  const {
    background,
    header: { background: headerBackground, title: titleStyles },
  } = useContext(ThemeContext);
  const headerEleStyles = css`
    padding-right: 44px;
    padding-left: 44px;
    margin-right: auto;
    margin-left: auto;
    z-index: ${Z_INDEX_MAP[Z_INDEX_NAV_KEY]};
    ${mapBackgroundToCSS(headerBackground || background)}
  `;

  const Title = styled.h2`
    padding-top: 44px;
    text-align: center;
    ${titleStyles?.font && mapFontViewToSerializedStyles(titleStyles?.font)}
    letter-spacing: 2px;
    a {
      color: inherit;
      &:hover {
        text-decoration: none;
      }
    }
    ${headerEleStyles}
  `;

  return (
    <>
      <Title>
        <a href={`/wedding/${slug}`}>{title}</a>
      </Title>
      <NavigationMenu navItems={navItems} slug={slug} css={headerEleStyles} />
    </>
  );
};

export default Header;
